import { Bars3Icon } from '@heroicons/react/24/outline'
import { useLocation } from 'wouter'
import { useAuthStore } from '@/store/authStore' 
import { Avatar } from '@/components/ui/Avatar'
import { Dropdown } from '@/components/ui/Dropdown'
import { Button } from '@/components/ui/Button' 
import { Calisma } from '../timer/Calisma'
import { NotificationBell } from './NotificationBell'
import { MessagesButton } from './MessagesButton'
import { SocialNavButtons } from './SocialNavButtons'

interface HeaderProps {
  onMenuClick: () => void
  role: 'student' | 'parent' | 'admin'
}

export const Header = ({ onMenuClick, role }: HeaderProps) => {
  const user = useAuthStore((state) => state.user)
  const logout = useAuthStore((state) => state.logout)
  const [, navigate] = useLocation() 

  const handleLogout = async () => {
    logout()
    navigate('/')
  }


  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-30">
      <div className="flex justify-between flex-row-reverse px-4 py-3">
        <div className="flex items-center gap-4">
          <Calisma />

          {role === 'student' && <MessagesButton />}

          {role === 'student' && <SocialNavButtons />}

          {role === 'student' && <NotificationBell />}

          <Dropdown
            trigger={
              <div className="flex items-center gap-2">
                <Avatar name={user?.name || ''} />
              </div>
            }
            items={[
              { label: 'Profil', onClick: () => navigate(`/${role}`) },
              { label: 'Ayarlar', onClick: () => navigate(`/${role}/ayarlar`) },
              { label: '', type: 'divider' as const },
              { label: 'Çıkış Yap', onClick: handleLogout },
            ]}
          />
        </div>

        <Button onClick={onMenuClick} variant="ghost" className="lg:hidden p-2">
          <Bars3Icon className="w-6 h-6" />
        </Button>
      </div>
    </header>
  )
}
